module.exports = __webpack_public_path__ + "img/changjing-03.4aaa8f86.png";